import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCMailPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5333" data-mp="2pb2m4bzk8a72">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5334" data-mp="2kfx2jjtmr7m5">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5335" data-mp="2am6euh5bv17i">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5336" data-mp="21nb9f7a3xv59">
              <XIcon className="w-6 h-6" data-id="element-5337" data-mp="1wq2lsr66wywm" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5338" data-mp="1rpwuxd7qvgfl">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-mail__pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5339" data-mp="2az5cxml4r1nq"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5340" data-mp="2ypja1riknqp6">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5341" data-mp="2jrqwh4wl5cdm">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5342" data-mp="2oq24rb78fetq" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5343" data-mp="3fyv8xayzql7t">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5344" data-mp="319z19f0uja7q">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5345" data-mp="317v0v725otc7">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5346" data-mp="2wbxk4zmzdkyw" />
          <div className="hidden md:block" data-id="element-5347" data-mp="2iatlcsaz7au0">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5348" data-mp="2ic4wjd6r3kv5">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5349" data-mp="o153uv99mr0r">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5350" data-mp="12rcbsh1ncrn7">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5351" data-mp="54wubf97ztzn">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5352" data-mp="jz1h3ah5c006">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5353" data-mp="1t2ehoeofktoq">
        <div className="md:col-span-7" data-id="element-5354" data-mp="1p240s6z3oiv3">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5355" data-mp="22zsmti4wlw1q">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-2xl md:text-3xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5356" data-mp="1xzo4rnockt9e">
            Ontdek hoe honden via lichaamstaal heel de dag stiekem tegen je
            praten, en hoe je als mens terug praat in dezelfde taal zodat ze jou
            direct begrijpen.
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5357" data-mp="2lps5nna5iewp">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5358" data-mp="2qrhkzf4epeql">
            <div className="flex -space-x-3" data-id="element-5359" data-mp="3acrid9qftzi9">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5360" data-mp="3ed1meguo6fuh" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5361" data-mp="35b24lmbtz7qh" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5362" data-mp="2hmrdhavxsmfe" />
            </div>
            <div data-id="element-5363" data-mp="27pd5lzo2x5yp">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5364" data-mp="27qxr6zsf1ekf">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5365" data-mp="2cn68oju35jur">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5366" data-mp="1osmdzkk23bbj">
            Ontdek in dit gratis 90-minuten webinar de eenvoudige, liefdevolle
            methode die duizenden hondenbaasjes al gebruiken om een betere band
            met hun hond te krijgen en gedragsproblemen aan te pakken zonder
            straffen en corrigeren. Straks weet je:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5367" data-mp="2cfkuujc38l9z">
            {['De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je hem helpt', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-5368" data-mp="32reioozjqmjb" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5369" data-mp="32pv2eydw4bhj" />
                <span className="text-gray-700 font-medium" data-id="element-5370" data-mp="37pprqxi0ot0h">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5371" data-mp="3cjk8pt68mtvv">
            <div className="flex -space-x-3" data-id="element-5372" data-mp="3hg2aqla6oe4i">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5373" data-mp="3lifex59a83z6" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5374" data-mp="3vfadfo5k24dg" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5375" data-mp="6uqdlx2uyr48" />
            </div>
            <div data-id="element-5376" data-mp="gjrtln9el8i7">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5377" data-mp="gme1xp44bs1h">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5378" data-mp="blyoyynr0mk1">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5379" data-mp="3f2yqthr240zc">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5380" data-mp="3f4jkz69glhwo">
            <div className="flex justify-center items-center w-full" data-id="element-5381" data-mp="3u10x3zph30ka">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-mail__pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5382" data-mp="3p03e5kwn22hq"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5383" data-mp="16uac3onrptyb">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5384" data-mp="16v2993x0jzqp">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5385" data-mp="1ujmn8u2noc39">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5386" data-mp="1zifx8ciqhkyo">
            <div className="flex flex-col items-center" data-id="element-5387" data-mp="1lsm7lrzemwnw">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5388" data-mp="1lq017vo92n79" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5389" data-mp="2i9z1emohv52a">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5390" data-mp="13lcvef9oo74w">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5391" data-mp="18iv8mhuqh8ip">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5392" data-mp="tn5sv1g55rmf" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5393" data-mp="kttwajis5d85">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5394" data-mp="plk70qlmq303">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5395" data-mp="fv93341y3tt7">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5396" data-mp="fvsavrxvt1ti" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5397" data-mp="3jdwurzfl3fnn">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5398" data-mp="3efbvc285p009">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5399" data-mp="3sgekwoyd0sfx">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5400" data-mp="ezypbgszjvxk">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5401" data-mp="ezozpuburqse">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5402" data-mp="ay3gzscn0iaa">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-5403" data-mp="jzti5pwbmvl9" />
            <span className="italic" data-id="element-5404" data-mp="k0coe9clzvjg">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5405" data-mp="3dsui0affluji">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5406" data-mp="3hsd1r2vinzkr">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5407" data-mp="3mry1vgmfadz2">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5408" data-mp="3rk8zgctoxnog"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5409" data-mp="2g3rgnfj0njka">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5410" data-mp="28krxnazgvu1g">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5411" data-mp="1ytx9g12nukdd"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5412" data-mp="16614ya6uno61">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5413" data-mp="123xqrdssq5h2">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5414" data-mp="2pz1ak82jr4gn"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5415" data-mp="33rqyii1myjge">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5416" data-mp="33tv9fjxyciq6">
              <div className="flex items-center mb-4" data-id="element-5417" data-mp="1o9yxcuabw1qm">
                <div className="flex text-green-500 mr-2" data-id="element-5418" data-mp="1sd3u0g7q997c">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5419" data-mp="1ksb2equ08pdv" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5420" data-mp="1ftgfbcp08eny">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5421" data-mp="1uq7fho6i5uem">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5422" data-mp="1221ud0bje3e9">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5423" data-mp="141xsd83hvi6p">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5424" data-mp="181oo7q7vooi3">
              <div className="flex items-center mb-4" data-id="element-5425" data-mp="1curaree8mxos">
                <div className="flex text-green-500 mr-2" data-id="element-5426" data-mp="1hst3kr1gubdg">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5427" data-mp="l2tm273c82iq" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5428" data-mp="p3lvp1g4g9fj">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5429" data-mp="u3i2f8g7eeys">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5430" data-mp="z3cpt20rsmf3">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5431" data-mp="3gacrmn5pv93t">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5432" data-mp="37a7vxa9vxz5h">
              <div className="flex items-center mb-4" data-id="element-5433" data-mp="32av92pj0ks2w">
                <div className="flex text-green-500 mr-2" data-id="element-5434" data-mp="32bmwve6ddlim">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5435" data-mp="2xdlbgmlh1a3z" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5436" data-mp="10he45tm9q5bu">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5437" data-mp="vl6ubpqr49om">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5438" data-mp="9ee79dkwq2fp">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5439" data-mp="1737sdcm2xkmf">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5440" data-mp="1b1dto545f7zy">
              <div className="flex items-center mb-4" data-id="element-5441" data-mp="2vlse07w5riy8">
                <div className="flex text-green-500 mr-2" data-id="element-5442" data-mp="2rkqdlnqi90uo">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5443" data-mp="35cdmcn1mw1uc" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5444" data-mp="30jtzezh23ucv">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5445" data-mp="3f8gkzixa1icj">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5446" data-mp="3acrjvb5lzte4">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5447" data-mp="1tvnez0lh53z5">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5448" data-mp="1oz6r87i6srml">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5449" data-mp="11zbsavygitml">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5450" data-mp="120mqmg94v96b">
          <div data-id="element-5451" data-mp="easek0wn1on4">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5452" data-mp="eaamlgh0dwl0">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5453" data-mp="napb0op9rrsq">
              <p data-id="element-5454" data-mp="ibcc35l4iu9s">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-5455" data-mp="227a20m072tmc">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-5456" data-mp="2ky1broo3gm19">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-5457" data-mp="38nc189zzuu03">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-5458" data-mp="38jlequu09v79">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5459" data-mp="2usf360dgc740">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5460" data-mp="2pu5co32o9uoq" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5461" data-mp="2bwgn4hxntzdc">
        <div className="max-w-md mx-auto px-4" data-id="element-5462" data-mp="rd3hqupsev22">
          <div className="p-6 rounded-3xl w-full" data-id="element-5463" data-mp="rcbjfc4t2j83">
            <div className="flex justify-center items-center" data-id="element-5464" data-mp="wc695ccuh2rk">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-mail__pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5465" data-mp="wad2hx28eijk"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5466" data-mp="me0ar4q8yerg">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5467" data-mp="mfbej4jozmik">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5468" data-mp="3l3h73sgodz2w" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5469" data-mp="1rl9z9y8sja65">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5470" data-mp="25d807lsclzr8">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5471" data-mp="2favxaidffjck">
            <p className="mb-2" data-id="element-5472" data-mp="2fcytjk56a8pq">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5473" data-mp="2obk8l5bfr5lr">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5474" data-mp="614w2ce5as10" />
    </div>;
}